const getProductCollectionModel = (collection = {}) => {
  const { actions = {}, headings = {} } = collection;
  // actions
  const { cta = {} } = actions;
  const { target: ctaHref, text: ctaText } = cta;
  // headings
  const { heading: carouselHeadingModel = {}, subheading: subheadingModel = {} } = headings;
  const { text: heading = 'No carousel heading' } = carouselHeadingModel;
  const { text: subheading = 'No carousel subheading' } = subheadingModel;

  return {
    // actions
    ctaHref,
    ctaText,

    // headings
    heading,
    subheading,
  };
};

// eslint-disable-next-line arrow-body-style
const getProductSlidesModel = (products) => {
  return products.map((props, index) => {
    const {
      brand,
      link,
      cleanTitle,
      regularPrice,
      thumbnailImageLink,
      displayPrice: {
        priceDisplay: {
          compareAtPrice = '', price = '', salePrice = '', priceDisplayType = '',
        },
      },
    } = props;
    let displayPrice = price || '';
    if (priceDisplayType === 'PRICE_RANGE') {
      displayPrice = `$${parseFloat(regularPrice).toFixed(2)}`;
    } else if (priceDisplayType === 'SALE_PRICE') {
      displayPrice = compareAtPrice;
    }
    return {
      key: `k${index}`,
      props: {
        brand,
        index,
        link,
        price: displayPrice,
        salePrice,
        title: cleanTitle,
        thumb: thumbnailImageLink,
      },
    };
  });
};

export { getProductSlidesModel, getProductCollectionModel };
